import {
  getAccessToken,
  removeAccessToken,
  removeUser,
} from "./token";

export async function authFetch(url, params = {}) {
  const token = getAccessToken();

  const isFormData =
    typeof FormData !== "undefined" &&
    params.body instanceof FormData;

  const headers = {
    ...(params.headers || {}),
    Accept: "application/json",
  };

  if (params.body && !isFormData) {
    headers["Content-Type"] = "application/json";
  }

  if (isFormData) {
    delete headers["Content-Type"];
    delete headers["content-type"];
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    cache: "no-store",
    ...params,
    headers,
  });

  if (response.status === 401) {
    removeAccessToken();
    removeUser();
  }

  return response;
}